import { Component, OnInit } from '@angular/core';
import { provideComponentStore } from '@ngrx/component-store';

import { SellerCollectDataState, SellerCollectDataSteps, CreateSellerCollectDataStore } from './create-seller-flow.store';

@Component({
  selector: 'app-create-seller-flow',
  templateUrl: './create-seller-flow.component.html',
  providers: [provideComponentStore(CreateSellerCollectDataStore)],
})
export class CreateSellerFlowComponent implements OnInit {
  public step$ = this.cs.currentStep$;
  public steps = SellerCollectDataSteps;

  constructor(public readonly cs: CreateSellerCollectDataStore) {}

  public ngOnInit(): void {
    this.setInitialData();
  }
  private setInitialData(): void {
    const state = {
      currentStep: SellerCollectDataSteps.PersonalData,
    } as SellerCollectDataState;
    this.cs.setState(state);
  }
}
